import { Component, OnInit, Input } from '@angular/core';
import { Activity, ActivityCost, Activitykpi, Partecipant, Project } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SortDirection } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/';
import { forkJoin } from 'rxjs';
import { ProjectCostsEditComponent } from '../project-costs-edit/project-costs-edit.component';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-project-costs-list',
	templateUrl: './project-costs-list.component.html',
	styleUrls: ['./project-costs-list.component.scss']
})
export class ProjectCostsListComponent implements OnInit {


	@Input()
	projectid: number;

	@Input()
	companyid: number;
	project: Project;
	partecipant: Partecipant;

	loading: boolean = false;


	advancedSearch: Search = new Search('activityexpense', 'name', 'activityexpense');
	rows: ActivityCost[];
	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	constructor(
		private costsService: CrudService<ActivityCost>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private projectService: CrudService<Project>,
		private modalService: NgbModal
	) {
		this.advancedSearch.setSortDirection(SortDirection.DESCENDING);
		this.advancedSearch.setSortField('id');
	}

	ngOnInit() {

		if (this.projectid) {
			this.projectService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => {
				this.project = p;
				this.advancedSearch.addSimpleFilter('projectid', this.project.id);
				this.load();
			});
		}
	}

	load(): void {

		this.loading = true;
		this.rows = [];


		const datarequest = this.costsService.searchEntities(ActivityCost, 'activityexpense', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.costsService.countEntities(ActivityCost, 'activityexpense', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.load();
	}

	edit(activitycostid: number): void {
		const modal = this.modalService.open(ProjectCostsEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.companyid = this.companyid;
		modal.componentInstance.projectid = this.projectid;
		modal.componentInstance.load(activitycostid);


		modal.result.then(() => {
			this.load();
		}).catch(() => { });
	}

	delete(activitycost: ActivityCost, event: any): void {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-activitycost-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.costsService.deleteEntity(ActivityCost, 'activityexpense', activitycost).subscribe(() => {
					this.translateService.get(['labels.activitycost-deleted', 'labels.activitycosts']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.activitycost-deleted'], messages['labels.activitycosts']);
						this.load();
					});
				});
			}
		});
	}

}
